import { render } from "./HomeMyKK.vue?vue&type=template&id=9b5f9fd2"
import script from "./HomeMyKK.vue?vue&type=script&lang=js"
export * from "./HomeMyKK.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__